import VideoPlayer from './player/script';

export default {
	[VideoPlayer.selector]: VideoPlayer
};
